/**
 * Build a Google Maps URL that opens a location in a new tab. Prefers the Google
 * `place_id` for an exact match, falling back to a free-text query when only the
 * typed text is known. Returns '' for an empty query so callers can skip the link.
 */
export function buildMapUrl(query: string, placeId?: string | null): string {
  const q = query.trim();
  if (!q) return '';
  const params = new URLSearchParams({ query: q });
  if (placeId) params.set('query_place_id', placeId);
  return `https://www.google.com/maps/search/?api=1&${params.toString()}`;
}
